if (!customElements.get('juronoid-home')) {
  customElements.define('juronoid-home', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.addEventListener('change', () => this.updateMessage());
      this.addEventListener('input', event => {
        if (event.target.matches('[data-inquiry]')) this.updateMessage();
      });
      this.updateMessage();
      const references = this.querySelector('[data-references]');
      const toggle = this.querySelector('[data-logo-toggle]');
      if (references && toggle) {
        const label = toggle.querySelector('[data-logo-label]');
        toggle.addEventListener('click', () => {
          const paused = toggle.getAttribute('aria-pressed') !== 'true';
          toggle.setAttribute('aria-pressed', String(paused));
          references.classList.toggle('is-paused', paused);
          label.textContent = paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
        });
        toggle.hidden = false;
        references.classList.add('is-enhanced');
      }
    }
    updateMessage() {
      const number = (this.dataset.whatsappNumber || '').replace(/\D/g, '');
      const intent = this.querySelector('.jh-intents input:checked');
      const message = this.querySelector('[data-inquiry]');
      const link = this.querySelector('[data-whatsapp-link]');
      if (!number || !link) return;
      const parts = [this.dataset.whatsappGreeting, intent ? intent.value : '', message ? message.value.trim().slice(0, 500) : ''];
      link.href = `https://wa.me/${number}?text=${encodeURIComponent(parts.filter(Boolean).join('\n\n'))}`;
    }
  });
}
